const API_BASE_URL = 'https://go-gin-certificate-portal.onrender.com';
// const API_BASE_URL = 'http://localhost:8080';

export const fetchAllCertificates = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/allDetailsCertificates`);
        if (!response.ok) {
            throw new Error('Failed to fetch certificates');
        }
        
        const result = await response.json();
        
        if (result.status === 200 && Array.isArray(result.data)) {
            return result.data.map(cert => ({
                ...cert,
                id: cert.serialNumber, // Using serialNumber as the unique identifier
                phone: cert.phone,
                name: cert.name,
                fathersName: cert.fathersName,
                dob: cert.dob,
                registrationNumber: cert.registrationNumber,
                course: cert.course,
                startMonth: cert.startMonth,
                endMonth: cert.endMonth,
                grade: cert.grade,
                serialNumber: cert.serialNumber,
                issueDate: cert.issueDate
            }));
        } else {
            throw new Error(result.message || 'Failed to fetch certificates');
        }
    } catch (error) {
        console.error('Error fetching certificates:', error);
        throw error;
    }
};

export const addCertificate = async (payload) => {
    try {
        const response = await fetch(`${API_BASE_URL}/addCertificate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || 'Failed to add certificate');
        }

        const result = await response.json();
        if (result.status === 200) {
            return result.data;
        }

        throw new Error(result.message || 'Failed to add certificate');
    } catch (error) {
        console.error('Error adding certificate:', error);
        throw error;
    }
};